import { observer } from 'mobx-react';
import * as React from 'react';
import { DragHandleProps } from '../../../../../../../Draggable/Types';
import { ExperienceResource } from '../../../../../Types';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../../Types';
import ExperienceRowItems from './ExperienceRowItems';
import ExperienceRowItemsWithHandlers from './ExperienceRowItemsWithHandlers';

interface Props {
  context: ModifiableExperiencesContext;
  experienceResource: ExperienceResource;
  store: LearningCollectionEditStore;
  dragHandleProps: DragHandleProps;
}

const CustomizeRow: React.FC<Props> = ({ context, experienceResource, store, dragHandleProps }) => {
  switch (context.kind) {
    case 'section-context':
      switch (context.section.resource.payload.learningDesignState) {
        case 'curated':
          return (
            <ExperienceRowItems
              context={context}
              experienceResource={experienceResource}
              store={store}
              showLockIcon="show"
            />
          );
        case 'curated-custom':
        case 'custom':
        case 'empty':
        case 'blank':
        case 'build-your-own':
        case 'browse-all':
          return (
            <ExperienceRowItemsWithHandlers
              context={context}
              store={store}
              experienceResource={experienceResource}
              dragHandleProps={dragHandleProps}
              showLockIcon="show"
            />
          );
      }
    case 'browse-all-experiences':
      return (
        <ExperienceRowItemsWithHandlers
          context={context}
          store={store}
          experienceResource={experienceResource}
          dragHandleProps={dragHandleProps}
          showLockIcon="hide"
        />
      );
  }
};

export default observer(CustomizeRow);
